import { Component, OnInit } from '@angular/core';
import { IdentificationService } from '@api/identification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { identificationRequestData } from '@shared/model/idenification.model';
import { PageEvent } from '@angular/material/paginator';
import jalaliMoment = require('jalali-moment');

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.scss']
})
export class IdentificationComponent implements OnInit {
  public destroy$ = new Subject<void>();
  identifiRequest: identificationRequestData;
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  pageEvent: PageEvent;
  providerInfo: any;
  constructor(
    private IdentiService: IdentificationService,
  ) { }

  ngOnInit(): void {
    this.IdentiService.getIdentification(this.startPage, this.pageSize).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.identifiRequest = res;
        this.identifiRequest.res_un_auth_providers.forEach(element => {
          element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize;
    this.IdentiService.getIdentification((event.pageIndex) + 1, this.pageSize).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.identifiRequest = res;
        this.identifiRequest.res_un_auth_providers.forEach(element => {
          element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
}
